import { render, staticRenderFns } from "./CollectCardContent.vue?vue&type=template&id=574775b6&scoped=true"
import script from "./CollectCardContent.vue?vue&type=script&lang=js"
export * from "./CollectCardContent.vue?vue&type=script&lang=js"
import style0 from "./CollectCardContent.vue?vue&type=style&index=0&id=574775b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574775b6",
  null
  
)

export default component.exports